import ArtistMetadataAPI from '@/api/artist/metadata';
import * as creatorsApi from '@/api/artist/creators';
import * as releasesApi from '@/api/artist/releases';
// import * as artistMediaTypesApi from '@/api/artist/media-types-new.js';
import * as artistCategoriesApi from '@/api/artist/categories.js';

const state = {
  fileId: null,
  mt: null,
  passedSteps: [],
  fields: [],
  rows: [],
  options: [],
  updatedFields: {},
  categories: [],

  elementCategories: [],
  elementCreators: [],
  elementReleases: [],

  // creators
  publisher: [],
  composer: [],
  arranger: [],
  performer: [],

  // releases
  model_release: [],
  property_release: [],

  tags: null,
  replaceMetadata: false,

  // import progress
  finished: false,
};

const getters = {
  getColumn: ({ fields }) => (column) => fields.filter(x => x.matchedField === column).map(x => x.column),
  isCreatorsValid({ mt }) {
    return mt === 'music';
  },
  allCreators(state) {
    return [...state.publisher, ...state.composer, ...state.arranger, ...state.performer];
  },
  allReleases(state) {
    return [...state.model_release, ...state.property_release];
  },
  isReleasesValid({ mt }) {
    return ['video', 'image'].includes(mt);
  },
  fieldMap({ fields }) {
    return fields
      // .filter(field => options.map(x => x.id).includes(field.matchedField))
      .map(field => ({
        columnIndex: field.columnIndex,
        field: field.matchedField ? field.matchedField : false,
      }));
  },
  categoryMap({ categories }) {
    return categories.map(category => ({
      value: category.value,
      categoryId: category.matchedCategoryId,
    }));
  },
  // eslint-disable-next-line
  creatorMapByType: (state) => (creatorType) => {
    return state[creatorType].map(creator => ({
      value: creator.value,
      id: _.get(creator.matchedCreator, 'id'),
    }));
  },
  // eslint-disable-next-line
  releaseMapByType: (state) => (releaseType) => {
    return state[releaseType].map(release => ({
      value: release.value,
      id: _.get(release.matchedRelease, 'id'),
    }));
  },
};

const actions = {
  SET_OPTIONS({ commit }, fileId) {
    return ArtistMetadataAPI.getFieldsOptions(fileId)
      .then(({ data: { data } }) => {
        commit('setOptions', data);
      });
  },
  SET_FIELDS({ commit }, fileId) {
    return ArtistMetadataAPI.getHeaders(fileId)
      .then(({ data: { data } }) => {
        // data.forEach(field => {
        //   field.key = field.matchedField;
        // });
        commit('setFields', data);
      });
  },
  SET_ROWS({ commit }, { fileId, params }) {
    return ArtistMetadataAPI.getRows(fileId, params)
      .then(({ data: { data, totalCount } }) => {
        data = data.slice(0, totalCount);
        data.shift();
        commit('setRows', data);
      });
  },
  // CATEGORIES
  SET_CATEGORIES({ commit }, fileId) {
    return ArtistMetadataAPI.getCategories(fileId)
      .then(({ data: { data } }) => {
        commit('setCategories', data);
      });
  },
  SET_ELEMENT_CATEGORIES({ commit }, { mediaType }) {
    // return artistMediaTypesApi.listMediaTypeCategories(mediaType)
    return artistCategoriesApi.listArtistCategories({
      media_type: mediaType,
      'fields[category]': 'id,name,type',
    })
      .then(response => {
        commit('setElementCategories', response.data.data);
      });
  },
  // CREATORS
  SET_CREATORS({ commit }, { id, type }) {
    return ArtistMetadataAPI.getCreators(id, type)
      .then(({ data: { data } }) => {
        commit('setProp', { prop: type, value: data });
      });
  },
  SET_ELEMENT_CREATORS({ commit }) {
    return creatorsApi.listCreators()
      .then(response => {
        commit('setElementCreators', response.data.data);
      });
  },
  // RELEASES
  SET_RELEASES({ commit }, { id, type }) {
    return ArtistMetadataAPI.getReleases(id, type)
      .then(({ data: { data } }) => {
        commit('setProp', { prop: type, value: data });
      });
  },
  SET_ELEMENT_RELEASES({ commit }) {
    return releasesApi.listReleaseFiles()
      .then(response => {
        commit('setElementReleases', response.data.data);
      });
  },
};

const mutations = {
  updateCategoryMatchedField({ categories }, { index, value }) {
    categories[index].matchedCategoryId = value;
  },
  updateCreatorMatchedField(state, { creatorType, index, value }) {
    state[creatorType][index].matchedCreator = { id: value };
  },
  updateReleaseMatchedField(state, { releaseType, index, value }) {
    state[releaseType][index].matchedRelease = { id: value };
  },
  setProp(state, { prop, value }) {
    state[prop] = value;
  },
  resetState(state) {
    state.fileId = null;
    state.mt = null;
    state.passedSteps = [];
    state.fields = [];
    state.rows = [];
    state.options = [];
    state.updatedFields = [];
    state.categories = [];
    state.publisher = [];
    state.composer = [];
    state.arranger = [];
    state.performer = [];
    state.model_release = [];
    state.property_release = [];
    state.elementCategories = [];
    state.elementCreators = [];
  },
  setMediaType(state, mt) {
    state.mt = mt;
  },
  addPassedStep({ passedSteps }, stepName) {
    const index = passedSteps.findIndex(step => step === stepName);
    if (index < 0) passedSteps.push(stepName);
  },
  removePassedStep({ passedSteps }, stepName) {
    const index = passedSteps.findIndex(step => step === stepName);
    if (index > -1) passedSteps.splice(index, 1);
  },
  // rows
  setRows(state, rows) {
    state.rows = rows;
  },
  // fields
  setFields(state, fields) {
    state.fields = fields;
  },
  setFieldByIndex({ fields }, { index, optionId }) {
    // const option = optionId ? options.find(option => option.id === optionId) : { id: false };
    const newField = {
      columnIndex: index,
      column: index + 1,
      header: fields[index].header,
      key: fields[index].key,
      matchedField: optionId,
    };
    fields.splice(index, 1, newField);
  },
  updateFieldByIndex({ fields }, { index, option }) {
    fields[index].header = option.name;
    fields[index].matchedField = option.id;
  },
  // options
  setOptions(state, options) {
    state.options = options;
  },
  // updatedFields
  setUpdatedFields(state, updatedFields) {
    state.updatedFields = updatedFields;
  },
  // categories
  setCategories(state, categories) {
    state.categories = categories;
  },
  setElementCategories(state, categories) {
    state.elementCategories = categories;
  },
  // creators
  setElementCreators(state, creators) {
    state.elementCreators = creators;
  },
  // releases
  setElementReleases(state, releases) {
    state.elementReleases = releases;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
